import { Map } from 'immutable';
import moment from 'moment';

// All Events
export const ALL_EVENT_FILTERS = Map({
  endOn: undefined,
  deleted: undefined,
  sortBy: { startOn: 1 }, // Sort in ascending order
});

// Active Events
export const UPCOMING_EVENT_FILTERS = Map({
  endOn: { $gt: moment().hour(0).minute(0).subtract(7, 'days').valueOf() },
  deleted: false,
  sortBy: { startOn: 1 }, // Sort in ascending order
});

// Recent Events
export const RECENT_EVENT_FILTERS = Map({
  endOn: {
    $gt: moment().hour(0).minute(0).subtract(14, 'days').valueOf(),
    $lte: moment().hour(0).minute(0).subtract(12, 'hours').valueOf(),
  },
  deleted: false,
  sortBy: { startOn: -1 }, // Sort in descending order
});

// Past Events
export const PAST_EVENT_FILTERS = Map({
  endOn: { $lte: moment().hour(0).minute(0).subtract(7, 'days').valueOf() },
  deleted: false,
  sortBy: { startOn: -1 }, // Sort in descending order
});

// Deleted Events
export const DELETED_EVENT_FILTERS = Map({
  endOn: undefined,
  deleted: true,
  sortBy: { startOn: 1 }, // Sort in ascending order
});

export default {
  ALL_EVENT_FILTERS,
  UPCOMING_EVENT_FILTERS,
  PAST_EVENT_FILTERS,
  RECENT_EVENT_FILTERS,
  DELETED_EVENT_FILTERS,
};
